/*
 * Responsive horizontal form — the same idea as Bootstrap's `.form-horizontal`
 * (label beside the control instead of above it), but driven by the FORM's own
 * width via a container query rather than a viewport media query.
 */
.horizontal {
	container-type: inline-size;
}

@container (min-width: 480px) {
	/* Each field becomes a two-column grid: [ label | control ]. */
	.horizontal :global([data-slot="field"]) {
		display: grid;
		grid-template-columns: minmax(140px, 30%) minmax(0, 1fr);
		column-gap: 15px;
		align-items: start;
	}

	/* Label → left column, right-aligned and nudged down to sit on the control's
	   baseline (mirrors Bootstrap's `.form-horizontal .control-label`). */
	.horizontal :global([data-slot="field"] > [data-slot="field-label"]) {
		grid-column: 1;
		justify-self: end;
		text-align: right;
		margin-bottom: 0;
		padding-top: 7px;
	}

	/* Control + description + error → right column, stacked in source order. */
	.horizontal :global([data-slot="field"] > :not([data-slot="field-label"])) {
		grid-column: 2;
	}
}
